// extracted by mini-css-extract-plugin
module.exports = {"codeTag":"CodeTag_codeTag__J6R1f","codeTag--selected":"CodeTag_codeTag--selected__3pQqe","tooltipWrapper":"CodeTag_tooltipWrapper__neZx1"};